export default __webpack_public_path__ + "static/media/picture-4.cd4151d9.png";